<div class="mb-6 flex ">
  <mat-form-field
    class="textarea-form-field w-full input-main bg-opaque mr-4"
    appearance="outline"
  >
      <textarea
        [(ngModel)]="noteDescription"
        #autosize="cdkTextareaAutosize"
        cdkAutosizeMaxRows="5"
        cdkAutosizeMinRows="1"
        cdkTextareaAutosize
        matInput
        placeholder="Add Comment..."
      ></textarea>
  </mat-form-field>
  <button
    class="btn-green btn-small mr-2"
    (click)="addNote()"
    [disabled]="!noteDescription.trim().length || postNoteLoading()"
  >
    @if (postNoteLoading()) {
      <mat-spinner
        class="mr-1"
        color="primary"
        diameter="20"
      />
    }
    Send
  </button>
</div>

@for (note of notes(); track note.id) {
  <avs-incident-note [note]="note" />
}
